import { ReactComponent as InfoIcon } from "@/assets/icons/info-t22-1.svg";

interface IProps {
  label: string;
  onClick: () => void;
}

const HelpButtonT22 = ({ onClick, label }: IProps) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex items-center gap-2 text-purple10 whitespace-nowrap text-base font-bold underline underline-offset-4 hover:font-extrabold"
  >
    <InfoIcon className="shrink-0 group-hover:fill-purple10 group-hover:text-white" />
    {label}
  </button>
);

export { HelpButtonT22 };
